// tag-pie-chart.component.ts
import {ChangeDetectorRef, Component, Input, OnChanges, ChangeDetectionStrategy} from '@angular/core';
import { ApexNonAxisChartSeries, ApexChart, ApexResponsive, ApexLegend, ApexDataLabels, ApexTooltip, ApexPlotOptions, NgApexchartsModule } from 'ng-apexcharts';

export type ChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    labels: string[];
    responsive: ApexResponsive[];
    legend: ApexLegend;
    dataLabels: ApexDataLabels;
    tooltip: ApexTooltip;
    plotOptions: ApexPlotOptions;
    colors: string[];
};

@Component({
    selector: 'app-tag-pie-chart',
    templateUrl: './tag-pie-chart.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgApexchartsModule]
})
export class TagPieChartComponent implements OnChanges {
    @Input() data: { label: string; value: number, color: string }[] = [];
    @Input() chartOptions: Partial<ChartOptions>;

    chartDataLabels: ApexDataLabels = {
        enabled: false
    }

    constructor(private cdr: ChangeDetectorRef) {}
    ngOnChanges(): void {
        if (this.data) {
            console.log('Data provided for the chart:', this.data);
            setTimeout(() => {
                this.chartOptions.series = this.data.map((d) => d.value);
                this.chartOptions.labels = this.data.map((d) => d.label);
                this.chartOptions.colors = this.data.map((d) => d.color);
            }, 200);
        } else {
            console.log('No data provided for the chart');
        }
        this.cdr.detectChanges();
    }
}
